
jQuery(function($){
	/**
	 * Set cookieBar variables and run function
	 *
	 * https://github.com/kovarp/jquery.cookieBar
	 */
	
	/**
	 * Run functions
	 */
	blockSlider();
	rwdMenu();
    inifFancybox();
	tabNav();
	phoneMain();
	goTo();
	apartamentNav();
	mapNav();
	contactUs();
	apartamentsFilter();
	showDialog();
	siteMenu();

	jQuery(document).ready(function($) {
  // 1. Ukryj wszystkie .price-history-item na start
  $('.price-history-item').hide();

  // --- Stary kod: globalny select z id="price-history"
  $('.single-flat__description #price-history').on('change', function() {
    const selectedDate = $(this).val();
    $('.price-history-item').hide();

    if (selectedDate === '') return;

    $('.price-history-item[data-date="' + selectedDate + '"]').show();
  });

  // --- Nowy kod: działa w tabeli, obsługuje wiele selectów w każdym wierszu
  $('table').on('change', 'select[name="price-history"]', function() {
    const selectedDate = $(this).val();
    const $row = $(this).closest('tr'); // tylko w tym wierszu

    // Ukryj wszystkie elementy historii w tym wierszu
    $row.find('.price-history-item').hide();

    if (selectedDate === '') return;

    // Pokaż tylko pasującą datę w tym wierszu
    $row.find('.price-history-item[data-date="' + selectedDate + '"]').show();
  });
});

	function siteMenu() {
		var window_width = jQuery(window).width();
		
		jQuery(".page-id-2 .internal a, .page-id-2 .site-header__logo, .page-id-2 .site-footer__logo").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
          console.log(href);
		  if(href == "#kontakt") {
			var pos = 0;
		  } else {
		  	var pos = 110;
		  }
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  
		});
		
  
		jQuery(".page-id-3953 .site-header__logo, .page-id-3953 .site-footer__logo, .page-id-3953 .inside-en a").click(function(event) {
		  event.preventDefault(); 
		
		  var href = jQuery(this).attr('href');
		  var href = href.substring(1, href.length);
		  var pos = 70;
		  var href = href.replace("en/", "");
		
		
		  jQuery('html, body').animate({
		  scrollTop: jQuery(href).offset().top - pos
		  }, 200);
		
		  jQuery('body').addClass('clicked');
		  if (window_width < 768) {
		  jQuery('#hamburger').removeClass('open');
		  jQuery('.site-header__navigation ul').slideUp(400);
		  }
		});
	  }

    if (window.location.hash) {
		console.log('hash');
        const targetId = window.location.hash; // Pobierz hash (np. #section1)
        const $target = $(targetId); // Znajdź element o podanym ID

        if ($target.length) {

			if(targetId == "#podklucz") {
				var pos = 300;
			} else {
				var pos = 200;
			}
            // Jeśli element istnieje, przewiń do niego z offsetem -200px
            $('html, body').animate({
                scrollTop: $target.offset().top - pos
            }, 500); // Animacja przewijania trwa 500ms
        }
    }
	

	function showDialog() {
		var screenWidth = $(window).width();


		$('.apartaments__map svg a').on('click', function(event) {
			event.preventDefault();
		});
	
		$('a[data-flat]').mouseenter(function() {
			var flatId = $(this).data('flat');
			var position = $(this).offset(); // Pobierz pozycję elementu
			var windowWidth = $(window).width(); // Pobierz szerokość okna przeglądarki
	
			// Sprawdź, czy kursor jest z lewej strony ekranu
			if(screenWidth > 1900) {
			var leftPosition = (position.left < windowWidth / 2) ? position.left - 50 : position.left - 450;
			} else {
				var leftPosition = (position.left < windowWidth / 2) ? position.left + 50 : position.left - 250;
			}
			// Pozycjonuj div 200px powyżej od odnośnika
			$('#' + flatId).css({
				position: 'absolute',
				top: position.top - 700,
				left: leftPosition,
				display: 'block'
			});
		}).mouseleave(function() {
			var flatId = $(this).data('flat');
			// Ukryj div po krótkim opóźnieniu, aby umożliwić przeniesienie kursora na div
			setTimeout(function() {
				if (!$('#' + flatId).is(':hover')) {
					$('#' + flatId).hide();
				}
			}, 100);
		});
	
		// Obsługa zdarzeń na divie, aby pozostawał widoczny po najechaniu
		$('div[id^="flat-"]').mouseenter(function() {
			$(this).show();
		}).mouseleave(function() {
			$(this).hide();
		});
	}
	


	function apartamentsFilter() {
		$('#find-flat select').on('change', function() {
			var params = new URLSearchParams(window.location.search);
	
			$('#find-flat select, #find-flat input[type="hidden"]').each(function() {
				var value = $(this).val();
				if (value) {
					params.set($(this).attr('name'), value);
				} else {
					params.delete($(this).attr('name'));
				}
			});
	
			// Sprawdź, czy wszystkie selecty są puste
			var allEmpty = true;
			$('#find-flat select').each(function() {
				if ($(this).val()) {
					allEmpty = false;
					return false; // Przerwij pętlę
				}
			});
	
			if (allEmpty) {
				params.delete('filter');
			} else {
				params.set('filter', 1);
			}
	
			// Sprawdź, czy jesteśmy na stronie głównej
			if ($('#top').length) {
				window.location.href = '/lista-lokali/?' + params.toString();
			} else {
				window.location.search = params.toString();
			}
		});
	}
	
	function contactUs() {
		$('.contact-us').click(function(event) {
			event.preventDefault();
			var houseName = $(this).attr('data-name');

			jQuery('#kontakt textarea').val(houseName+'. ');
			jQuery('#kontakt input[name="your-flat"]').val(houseName+'. ')
		});
	}

	function mapNav() {
		$(".map__switcher a").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			console.log(href);
			$(this).parent('div').children('span').toggleClass('right');
			$(".map__switcher a").removeClass('active');
			$(this).addClass('active');
			$('.map__wrapper > div').hide();
			$('.map__wrapper > div'+href).show();
		});

		$(".map__switcher span").click(function(event) {
			event.preventDefault();

			if($(this).hasClass('right')) {
				$(".map__switcher a").removeClass('active');
				$('.map__switcher a[href="#classic"').addClass('active');
				$('.map__wrapper > div').hide();
				$('.map__wrapper > div#classic').show();
				$(this).removeClass('right');
			} else {
				$(".map__switcher a").removeClass('active');
				$('.map__switcher a[href="#google-maps"').addClass('active');
				$('.map__wrapper > div').hide();
				$('.map__wrapper > div#google-maps').show();
				$(this).addClass('right');
			}
			
		});

		$(".categories-list a").click(function(event) {
			event.preventDefault();
			
			$(".categories-list a").removeClass('active');
			$(this).addClass('active');
		});

		$(".categories-list-classic a").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');

			$(".categories-list-classic a").removeClass('active');
			$(this).addClass('active');
			$('#classic img').hide();
			$('#classic img'+href).show();
		});
	}

	function apartamentNav() {

		$('.b-1').hover(
			function() {
				$('.bubble.b-b').addClass('active');
			},
			function() {
				$('.bubble.b-b').removeClass('active');
			}
		);

		$('.b-2').hover(
			function() {
				$('.bubble.b-c').addClass('active');
			},
			function() {
				$('.bubble.b-c').removeClass('active');
			}
		);

		$('.b-3').hover(
			function() {
				$('.bubble.b-d').addClass('active');
			},
			function() {
				$('.bubble.b-d').removeClass('active');
			}
		);

		$('.b-d_f-5').hover(
			function() {
				$('.bubble.b-d_f-5').addClass('active');
			},
			function() {
				$('.bubble.b-d_f-5').removeClass('active');
			}
		);

		$('.b-d_f-4').hover(
			function() {
				$('.bubble.b-d_f-4').addClass('active');
			},
			function() {
				$('.bubble.b-d_f-4').removeClass('active');
			}
		);

		$('.b-d_f-3').hover(
			function() {
				$('.bubble.b-d_f-3').addClass('active');
			},
			function() {
				$('.bubble.b-d_f-3').removeClass('active');
			}
		);

		$('.b-d_f-2').hover(
			function() {
				$('.bubble.b-d_f-2').addClass('active');
			},
			function() {
				$('.bubble.b-d_f-2').removeClass('active');
			}
		);

		$('.b-d_f-1').hover(
			function() {
				$('.bubble.b-d_f-1').addClass('active');
			},
			function() {
				$('.bubble.b-d_f-1').removeClass('active');
			}
		);

		$('.b-c_f-5').hover(
			function() {
				$('.bubble.b-c_f-5').addClass('active');
			},
			function() {
				$('.bubble.b-c_f-5').removeClass('active');
			}
		);

		$('.b-c_f-4').hover(
			function() {
				$('.bubble.b-c_f-4').addClass('active');
			},
			function() {
				$('.bubble.b-c_f-4').removeClass('active');
			}
		);

		$('.b-c_f-3').hover(
			function() {
				$('.bubble.b-c_f-3').addClass('active');
			},
			function() {
				$('.bubble.b-c_f-3').removeClass('active');
			}
		);

		$('.b-c_f-2').hover(
			function() {
				$('.bubble.b-c_f-2').addClass('active');
			},
			function() {
				$('.bubble.b-c_f-2').removeClass('active');
			}
		);

		$('.b-c_f-1').hover(
			function() {
				$('.bubble.b-c_f-1').addClass('active');
			},
			function() {
				$('.bubble.b-c_f-1').removeClass('active');
			}
		);

		$(".apartament-back").click(function(event) {
			event.preventDefault();
			$('.apartament__nav .step-1 em').show();
			$('.apartament__nav .step-1 svg').hide();
			$('.apartament__nav .step-1 span').html('Wybierz budynek');
			$('.apartament__nav .step-2 em').show();
			$('.apartament__nav .step-2 svg').hide();
			$('.apartament__nav .step-2 span').html('Wybierz piętro');
			$('.apartament__nav .step-3 div').show();
			$('.apartament__nav .step-3 span').html('Wybierz apartament');
			$('.apartament__wrapper > .step-2').fadeOut(500);
			$('.apartament__wrapper > .step-1').fadeIn(500);
		});

		$(".b-1").click(function(event) {
			event.preventDefault();
		});
		$(".b-2").click(function(event) {
			event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-1 em').hide();
			$('.apartament__nav .step-1 svg').show();
			$('.apartament__nav .step-1 span').html('Budynek D <span>('+apartaments+')</span>');
			$('.apartament__wrapper > .step-1').fadeOut(500);
			$('.building-d').fadeIn(500);
		});

		$(".b-3").click(function(event) {
			event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-1 em').hide();
			$('.apartament__nav .step-1 svg').show();
			$('.apartament__nav .step-1 span').html('Budynek C <span>('+apartaments+')</span>');
			$('.apartament__wrapper > .step-1').fadeOut(500);
			$('.building-c').fadeIn(500);
		});

		$(".b-d_f-5").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 4 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=d&floor=4" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-d_f-4").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 3 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=d&floor=3" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-d_f-3").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 2 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=d&floor=2" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-d_f-2").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 1 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=d&floor=1" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-d_f-1").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 0 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=d&floor=parter" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-c_f-5").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 4 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=c&floor=4" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-c_f-4").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 3 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=c&floor=3" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-c_f-3").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 2 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=c&floor=2" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-c_f-2").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 1 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=c&floor=1" class="btn white">Pokaż apartamenty</a>');
		});

		$(".b-c_f-1").click(function(event) {
			//event.preventDefault();
			var apartaments = $(this).attr('data-number');
			$('.apartament__nav .step-2 em').hide();
			$('.apartament__nav .step-2 svg').show();
			$('.apartament__nav .step-2 span').html('Piętro 0 <span>('+apartaments+')</span>');
			$('.apartament__nav .step-3 div').hide();
			$('.apartament__nav .step-3 span').html('<a href="/lista-lokali/?filter=1&vis=1&building=c&floor=parter" class="btn white">Pokaż apartamenty</a>');
		});
	}

	function goTo() {

		$(".go-to").click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			var pos = -100;
			jQuery('html, body').animate({
				scrollTop: jQuery(href).offset().top + pos
				}, 500);
		});
	  }

	function phoneMain() {
		$('.phone-main').hover(
			function() {
				// Funkcja uruchamiana, gdy najedziesz na element
				$(this).children('span').addClass('active');
			},
			function() {
				// Funkcja uruchamiana, gdy zjedziesz z elementu
				$(this).children('span').removeClass('active');
			}
		);
	}

	function tabNav() {
		

		$('.show-tab').click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			console.log(href);
			$('.show-tab').removeClass('active');
			$(this).addClass('active');
			$('.advantages__list').removeClass('active');
			$('.advantages__list').hide();
			$('.advantages__list'+href).show();
		});
	}

    $(function(){
        loopcounter('myCountdown');
      });
  function inifFancybox() {
    Fancybox.bind('[data-fancybox]', {
      Thumbs: false,
		  loop : true,

      afterClose: function(instance, current) {
        var videos = document.querySelectorAll('.inline-movies');

        // Loop through all videos with class 'inline-movies' and pause them
        videos.forEach(function(video) {
            video.pause();
        });
      }
		});
	  }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {
			
			
			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;
			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	 });
		}());
        $(window).scroll(function() {   
            var windowWidth = $(window).width();
            var scroll = $(window).scrollTop();
    
            if (scroll >= 50 ) {
                $("header").addClass("scrolled");
           
            } else {
                $("header").removeClass("scrolled");
            }
    
        });

	function blockSlider() {
		

		

		jQuery('.header-slider').owlCarousel({
		  loop:true,
		  margin:0,
		  nav:false,
		  items:1,
		  autoplay:true,
		  autoplayTimeout:4000,
		  autoplaySpeed: 1700,
		  slideSpeed: 1700,
		  navSpeed: 1700,
		  dotsSpeed: 1700,
		  dots: false,
		  singleItem: true,
		  navText: ["<",">"],
      		autoplayHoverPause:true
		  
		});

		jQuery('.seo-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ["<svg width='177' height='102' viewBox='0 0 177 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M176.5 51.0483H2M2 51.0483L52.0483 1M2 51.0483L52.0483 101.097' stroke='#4F4740' stroke-width='2'/></svg>","<svg width='176' height='102' viewBox='0 0 176 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.00390625 51.0483H174.496M174.496 51.0483L124.448 1M174.496 51.0483L124.448 101.097' stroke='#4F4740' stroke-width='2'/></svg>"],
			autoplayHoverPause:false
			
		  });

		jQuery('.gallery-slider').owlCarousel({
			loop:true,
			margin:50,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ["<svg width='177' height='102' viewBox='0 0 177 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M176.5 51.0483H2M2 51.0483L52.0483 1M2 51.0483L52.0483 101.097' stroke='#4F4740' stroke-width='2'/></svg>","<svg width='176' height='102' viewBox='0 0 176 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.00390625 51.0483H174.496M174.496 51.0483L124.448 1M174.496 51.0483L124.448 101.097' stroke='#4F4740' stroke-width='2'/></svg>"],
				autoplayHoverPause:true,
				responsive:{
				  0:{
					
					stagePadding: 50,
					items:1,
				  },
				  960:{
					items:1,
					stagePadding: 80,
				  },
				  1440:{
					  items:1,
					  stagePadding: 180,
					},
				  1900:{
					  items:1,
					  stagePadding: 260,
					},
				  
				}
		  });

		  jQuery('.testimonials-slider').owlCarousel({
			loop:true,
			margin:20,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ["<svg width='177' height='102' viewBox='0 0 177 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M176.5 51.0483H2M2 51.0483L52.0483 1M2 51.0483L52.0483 101.097' stroke='#4F4740' stroke-width='2'/></svg>","<svg width='176' height='102' viewBox='0 0 176 102' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.00390625 51.0483H174.496M174.496 51.0483L124.448 1M174.496 51.0483L124.448 101.097' stroke='#4F4740' stroke-width='2'/></svg>"],
				autoplayHoverPause:true,
				responsive:{
				  0:{
					items:1,
				  },
				  960:{
					items:2,
				  },
				  1100:{
					items:3,
				  },
				  1240:{
					items:4,
				  },
				  1440:{
					  items:5,
					},
				  1900:{
					  items:6,
					},
				  
				}
		  });
      
	 }

})